export default "__VITE_ASSET__aaac6557__"